import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { BannerComponent } from 'shared/ui-common';

import { NetworkStatusService } from '../../../shared/util-common/src/lib/services/network-status.service';

@Component({
  selector: 'tt-offline-page',
  templateUrl: './offline-page.component.html',
  styleUrls: ['./offline-page.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BannerComponent, RouterLink, TranslocoPipe, RouterOutlet],
  providers: [],
})
export class OfflinePageComponent {
  protected networkStatusService = inject(NetworkStatusService);
}
